import { useReducer } from "react";

export const initial: State = {
	showCheckPassRevokeDialog: false,
	showCheckPassCreatetDialog: false,
	deleteSecretId: ""
};

export interface State {
	showCheckPassRevokeDialog: boolean;
	showCheckPassCreatetDialog: boolean;
	deleteSecretId: string;
}

enum ActionType {
	showCheckPassRevokeDialog = "showCheckPassRevokeDialog",
	showCheckPassCreatetDialog = "showCheckPassCreatetDialog",
	hideCheckPassRevokeDialog = "hideCheckPassRevokeDialog",
	hideCheckPassCreatetDialog = "hideCheckPassCreatetDialog"
}

interface Action {
	type: string;
	val: string;
}

function reducer(state: State, action: Action): State {
	switch (action.type) {
		case ActionType.showCheckPassRevokeDialog:
			return { ...state, showCheckPassRevokeDialog: true, deleteSecretId: action.val };
		case ActionType.hideCheckPassRevokeDialog:
			return { ...state, showCheckPassRevokeDialog: false, deleteSecretId: "" };
		case ActionType.showCheckPassCreatetDialog:
			return { ...state, showCheckPassCreatetDialog: true };
		case ActionType.hideCheckPassCreatetDialog:
			return { ...state, showCheckPassCreatetDialog: false };

		default:
			throw new Error();
	}
}

export default function useSecretsCardActionsStore() {
	const [state, dispatch] = useReducer(reducer, initial);

	const actions = {
		showCheckPassRevokeDialog: (id: string) =>
			dispatch({ type: ActionType.showCheckPassRevokeDialog, val: id }),
		hideCheckPassRevokeDialog: () =>
			dispatch({ type: ActionType.hideCheckPassRevokeDialog, val: "" }),
		showCheckPassCreatetDialog: () =>
			dispatch({ type: ActionType.showCheckPassCreatetDialog, val: "" }),
		hideCheckPassCreatetDialog: () =>
			dispatch({ type: ActionType.hideCheckPassCreatetDialog, val: "" })
	};

	return [state, actions] as const;
}
